import { createSlice } from "@reduxjs/toolkit";

let defaultData = {
  details: {
    _id: "",
    userId: "",
    totalAmount: 0,
    badges: [],
    missions: [],
    rewards: [],
  },
  missions: [],
  rewards: [],
  badges: [],
  leaderboard: [],
  transactions: [],
  stats: {},
};
let initialState = {
  ...defaultData,
};

export const pointsSlice = createSlice({
  name: "points",
  initialState,
  reducers: {
    setPointsDetails: (state, action) => {
      state.details = action.payload;
    },
    setMissions: (state, action) => {
      state.missions = action.payload;
    },
    setBadges: (state, action) => {
      state.badges = action.payload;
    },
    setRewards: (state, action) => {
      state.rewards = action.payload;
    },
    setLeaderboard: (state, action) => {
      state.leaderboard = action.payload;
    },
    setPointsStats: (state, action) => {
      state.stats = action.payload;
    },
    setPointsTransactions: (state, action) => {
      state.transactions = action.payload;
    },
  },
});

export const {
  setPointsDetails,
  setMissions,
  setBadges,
  setRewards,
  setLeaderboard,
  setPointsStats,
  setPointsTransactions,
} = pointsSlice.actions;

export default pointsSlice.reducer;
